"use strict";

exports.__esModule = true;
var _defaultValue = require("./default-value");
Object.keys(_defaultValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultValue[key]) return;
  exports[key] = _defaultValue[key];
});
var _styleCssValue = require("./style-css-value");
Object.keys(_styleCssValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _styleCssValue[key]) return;
  exports[key] = _styleCssValue[key];
});
//# sourceMappingURL=index.js.map